import { isUrl } from "core/utils/Validators";

function hasValidSteps(steps: unknown) {
  if (typeof steps === "string") {
    return Boolean(steps.trim());
  }

  if (Array.isArray(steps)) {
    return steps.some(
      (step) => typeof step === "string" && Boolean(step.trim())
    );
  }

  return false;
}

const validate = (values: any, props?: any) => {
  const errors: any = {};

  if (!values.name) errors.name = "Name is required";
  if (!values.code) errors.code = "Code is required";
  if (!values.region) errors.region = "Region is required";
  if (!values.platformSupport) errors.platformSupport = "Platform is required";
  if (!values.type) errors.type = "Type is required";
  if (values.priceStartingFrom == null)
    errors.priceStartingFrom = "Starting price is required";
  if (!values.discountUpto) errors.discountUpto = "Discount Upto is required";
  if (values.isPopular === undefined || values.isPopular === null)
    errors.isPopular = "Popularity status is required";

  const container = values;

  // Only validate Game Info for non-giftcard types
  if (values.type !== "giftcard") {
    if (!container?.question) {
      errors.question = "Question is required";
    }

    if (!Array.isArray(container?.steps) || !container?.steps?.length) {
      errors.question = "At least one step is required";
    } else {
      const stepsErrorsData: any[] = [];

      container?.steps.forEach((step: any, index: number) => {
        const stepError: any = {};
        if (!step.desc) stepError.desc = "Step description is required";
        if (step.image && !isUrl(step.image))
          stepError.image = "Invalid step image URL";

        stepsErrorsData[index] = stepError;
      });
      if (stepsErrorsData.length) {
        errors.steps = stepsErrorsData;
      }
    }
  }

  if (Array.isArray(container?.description)) {
    const descErrors = container.description.map((description: any) => {
      const descriptionError: any = {};

      if (!description.heading?.trim()) {
        descriptionError.heading = "Heading is required";
      }

      if (!hasValidSteps(description.steps)) {
        descriptionError.steps =
          "At least one description step is required";
      }

      return Object.keys(descriptionError).length
        ? descriptionError
        : null;
    });

    if (descErrors.some(Boolean)) {
      errors.description = descErrors;
    }
  }

  if (Array.isArray(container?.howToUse)) {
    const useErrors = container.howToUse.map((howToUse: any) => {
      const useError: any = {};

      if (!howToUse.heading?.trim()) {
        useError.heading = "Heading is required";
      }

      if (!hasValidSteps(howToUse.steps)) {
        useError.steps = "At least one usage step is required";
      }

      return Object.keys(useError).length
        ? useError
        : null;
    });

    if (useErrors.some(Boolean)) {
      errors.howToUse = useErrors;
    }
  }

  if (
    values.type !== "giftcard" &&
    Array.isArray(container?.priceDenomination)
  ) {
    const priceErrors = container?.priceDenomination?.map((p: any) => {
      const pError: any = {};
      if (!p.unit) pError.unit = "Unit is required";
      if (p.price == null) pError.price = "Price is required";
      if (p.discountPrice == null)
        pError.discountPrice = "Discount price is required";
      return Object.keys(pError).length ? pError : null;
    });
    if (priceErrors.some(Boolean)) errors.priceDenomination = priceErrors;
  }

  // 🔑 Attach correctly based on mode
  // if (isEditMode) {
  //   if (Object.keys(containerErrors).length) errors.meta = containerErrors;
  // } else {
  //   Object.assign(errors, containerErrors);
  // }

  return errors;
};

export default validate;
